import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import { createInertiaApp, Link } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { registerSW } from 'virtual:pwa-register';
import { createApp, h, watch, type DefineComponent } from 'vue';

import { useDocumentWindowHotkeys } from '@/Composables/documentWindow';
import { useLanguage } from '@/Composables/spaceship';
import { loadActiveLanguageFile, i18nVue, setLanguage } from '@/Plugins/i18n';
import inertiaDuskPlugin from '@/Plugins/inertiaDusk';
import numbroPlugin from '@/Plugins/numbro';
import sentryVuePlugin from '@/Plugins/sentry';
import { themePlugin } from '@/Plugins/theme';

const appName = window.document.querySelectorAll('title')[0].textContent ?? 'com.Simple';

// global watcher for changing the locale
const locale = useLanguage();
watch(locale, (locale) => {
  setLanguage(locale);
});

// eslint-disable-next-line unicorn/prefer-top-level-await
loadActiveLanguageFile().then(() => {
  createInertiaApp({
    title: (title: string) => `${title} - ${appName}`,

    resolve: (name: string) =>
      resolvePageComponent(
        `./Pages/${name}.vue`,
        import.meta.glob<DefineComponent>('./Pages/**/*.vue'),
      ),

    progress: {
      color: '#ffffff',
    },

    defaults: {
      future: {
        useScriptElementForInitialPage: true,
      },
    },

    setup({ el, App, props, plugin }) {
      createApp({ render: () => h(App, props) })
        .use(plugin)
        .use(themePlugin)
        .use(i18nVue)
        .use(numbroPlugin)
        .use(autoAnimatePlugin)
        .use(sentryVuePlugin)
        .use(inertiaDuskPlugin)
        .component('InertiaLink', Link)
        .component('inertia-link', Link)
        .mount(el);

      useDocumentWindowHotkeys();
    },
  });
});

registerSW({ immediate: true });
